import * as React from 'react';

import {Badge} from 'shells/badge/badge';
// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from 'shells/icon/svg/close-icon';

import styles from './label-field-wrapper.module.css';

type Props = {
    onRemoveField: () => void;
    children: React.ReactElement<any>;
};

export function LabelFieldWrapper(props: Props) {
    return (
        <div className={styles['field-wrapper-container']}>
            <Badge
                contents={<CloseIcon size={8} fill='#fff' wrapWithDiv={false} />}
                onClick={(e) => {
                    // We need to stop this click from propagating and deselecting the field
                    e.stopPropagation();
                    props.onRemoveField();
                }}
                color='grey'
            />
            {props.children}
        </div>
    );
}
